import { useMemo } from 'react';

import { usePathname, useSearchParams } from 'next/navigation';

/**
 * Memoized on the pathname/search string (not recomputed on every unrelated
 * re-render): callers feed `filtersState.allTopics` into other hooks' own
 * useMemo dependency arrays (e.g. useGetStories' `options`), and a fresh array
 * reference on every render — regardless of whether the URL actually changed
 * — cascades into those memos recomputing too, which re-triggers a "first
 * page" query effect keyed on their output and silently discards anything
 * appended via fetchMore.
 */
export const useGetQueryFilters = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();

  return useMemo(() => {
    const topics = searchParams.getAll('topic');
    const topicFilters = searchParams.getAll('topicFilter');

    const url = new URL(pathname, 'http://placeholder.local');
    url.search = search;

    return {
      filtersState: {
        url,
        topics,
        topicFilters,
        allTopics: Array.from(new Set([...topics, ...topicFilters])),
        term: searchParams.get('term'),
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search]);
};
